import { Notify } from 'vant';
import tim from '@/tim';
import TIM from 'tim-js-sdk/tim-js-friendship'

export default {
	namespaced: true,
	state: {
		isReady: false, // sdk是否ready
		message: undefined, // 提示信息
		currentConversation: {}, // 当前会话
		currentMessageList: [], // 当前消息列表
		isCompleted: false, // 当前会话消息列表是否已经拉完了所有消息
		nextReqMessageID: '',   // 拉取消息列表的messageID
		conversationList: [],   // 会话列表
		groupList: [],  // 群组列表
		currentMemberList: [],  // 当前群成员列表
		currentUserProfile: {}, // 当前用户信息
		currentUserRole: '', // 当前用户角色 custom 客户 staff 政府人员
	},
	getters: {
		// 用于当前会话的图片预览
		imgUrlList: state => {
			return state.currentMessageList
				.filter(message => message.type === TIM.TYPES.MSG_IMAGE && !message.isRevoked) // 筛选出没有撤回并且类型是图片类型的消息
				.map(message => message.payload.imageInfoArray[0].url)
		},
		currentConversationType: state => {
			if (!state.currentConversation || !state.currentConversation.type) {
				return ''
			}
			return state.currentConversation.type
		},
		toAccount: state => {
			console.log('这里是vuex的toAccount啊啊啊啊啊啊', state.currentConversation.type);
			console.log('这里是vuex的toAccount啊啊啊啊啊啊', state.currentConversation.conversationID);

			if (!state.currentConversation || !state.currentConversation.conversationID) {
				return ''
			}
			switch (state.currentConversation.type) {
				case 'C2C':
					return state.currentConversation.conversationID.replace('C2C', '');
				case 'GROUP':
					return state.currentConversation.conversationID.replace('GROUP', '');
				default:
					return state.currentConversation.conversationID
			}
		},
		/**
		 * 是否是客户 从游云南端进入
		 * @param state
		 * @return {boolean}
		 */
		isCustom: state => {
			return state.currentUserRole === 'custom';
		},
		/**
		 * 当前会话是否单聊
		 * @param state
		 * @return {boolean}
		 */
		isC2C: state => {
			console.log('cccccccccccccc', state.currentConversation.conversationID);
			return state.currentConversation.conversationID && 
			(
				state.currentConversation.conversationID.includes('C2C') || state.currentConversation.conversationID.includes('GROUPTIO')
			)
		}
	},
	mutations: {
		/**
		 * 展示提示信息
		 * @param {Object} state
		 * @param {object} options
		 */
		showMessage(state, options) {
			if (state.message) {
				Notify.clear();
			}
			state.message = options.message;
			Notify({
				type: options.type || 'success',
				message: options.message,
				duration: options.duration || 2000,
				color: options.color || 'white',
			})
		},
		/**
		 * 将消息插入当前会话列表
		 * 调用时机：收/发消息事件触发时
		 * @param {Object} state
		 * @param {Message[]|Message} data
		 */
		pushCurrentMessageList(state, data) {
			// 还没当前会话，则跳过
			if (!state.currentConversation.conversationID) {
				return
			}
			if (Array.isArray(data)) {
				// 筛选出当前会话的消息
				const result = data.filter(item => item.conversationID === state.currentConversation.conversationID);
				state.currentMessageList = [...state.currentMessageList, ...result];
			} else if (data.conversationID === state.currentConversation.conversationID) {
				state.currentMessageList = [...state.currentMessageList, data];
			}
		},
		/**
		 * 更新会话列表
		 * 调用时机：触发会话列表更新事件时。CONVERSATION_LIST_UPDATED
		 * @param {Object} state
		 * @param {Conversation[]} conversationList
		 */
		updateConversationList(state, conversationList) {
			state.conversationList = conversationList
		},
		/**
		 * 重置当前会话
		 * 调用时机：需要重置当前会话时，例如：当前会话是一个群组，正好被踢出群时（被踢群事件触发），重置当前会话
		 * @param {Object} state
		 */
		resetCurrentConversation(state) {
			state.currentConversation = {}
		},
		/**
		 * 更新当前会话
		 * 调用时机: 切换会话时
		 * @param {Object} state
		 * @param {Conversation} conversations
		 */
		updateCurrentConversation(state, conversation) {
			state.currentConversation = conversation;
			state.currentMessageList = [];
			state.nextReqMessageID = '';
			state.isCompleted = false
		},
		/**
		 * 重置消息
		 * @param state
		 */
		reset(state) {
			Object.assign(state, {
				currentConversation: {},
				currentMessageList: [],
				nextReqMessageID: '',
				isCompleted: false,
				conversationList: []
			})
		},
		updateGroupList(state, groupList) {
			state.groupList = groupList
		},
		updateCurrentMemberList(state, memberList) {
			state.currentMemberList = [...state.currentMemberList, ...memberList]
		},
		/**
		 * 更新当前用户资料
		 * SDK ready时
		 * @param {Object} state
		 * @param {Object} userProfile
		 */
		updateCurrentUserProfile(state, userProfile) {
			state.currentUserProfile = userProfile;
		},
		updateCurrentUserRole(state, role) {
			state.currentUserRole = role;
		},
		updateReady(state, boolean) {
			state.isReady = boolean;
		}
	},
	actions: {
		/**
		 * 获取消息列表
		 * 调用时机：打开某一会话时或下拉获取历史消息时
		 * @param {Object} context
		 * @param {String} conversationID
		 */
		getMessageList(context, conversationID) {
			if (context.state.isCompleted) {
				context.commit('showMessage', {
					message: '已经没有更多的历史消息了哦',
					type: 'primary'
				});
				return
			}
			const { nextReqMessageID, currentMessageList } = context.state;
			tim.getMessageList({ conversationID, nextReqMessageID, count: 15 }).then(imReponse => {
				// 更新messageID，续拉时要用到
				context.state.nextReqMessageID = imReponse.data.nextReqMessageID;
				context.state.isCompleted = imReponse.data.isCompleted;
				// 更新当前消息列表，从头部插入
				context.state.currentMessageList = [...imReponse.data.messageList, ...currentMessageList];
			})
		},
		/**
		 * 更新群组列表
		 * 调用时机：群组列表更新时
		 * @param {Object} context
		 * @param {Object} groupList
		 */
		updateGroupList(context, groupList) {
			context.commit('updateGroupList', groupList)
		},
		/**
		 * 切换会话
		 * 调用时机：切换会话时
		 * @param {Object} context
		 * @param {String} conversationID
		 */
		checkoutConversation(context, conversationID) {
			console.log('checkoutConversation', conversationID)
			// 1.切换会话前，将切换前的会话进行已读上报
			if (context.state.currentConversation.conversationID) {
				const prevConversationID = context.state.currentConversation.conversationID;
				tim.setMessageRead({ conversationID: prevConversationID })
			}
			// 2.待切换的会话也进行已读上报
			tim.setMessageRead({ conversationID });
			// 3. 获取会话信息
			return tim.getConversationProfile(conversationID).then(({ data }) => {
				// 3.1 更新当前会话
				context.commit('updateCurrentConversation', data.conversation);
				// 3.2 获取消息列表
				context.dispatch('getMessageList', conversationID);
				// 3.3 拉取第一页群成员列表
				if (data.conversation.type === TIM.TYPES.CONV_GROUP) {
					return context.dispatch('getGroupMemberList', data.conversation.groupProfile.groupID)
				}
				return Promise.resolve()
			}).catch( res=>{
			})
		},
		/**
		 * 获取第一页群成员列表
		 * 调用时机：切换会话时
		 * @param {Object} context
		 * @param {String} groupID
		 */
		getGroupMemberList(context, groupID) {
			return tim.getGroupMemberList({
				groupID: groupID,
				offset: context.state.currentMemberList.length,
				count: 30
			}).then((imResponse) => {
				context.commit('updateCurrentMemberList', imResponse.data.memberList);
				return imResponse
			})
		}
	}
}
